var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterBackground(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1998.9 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f3f5ff;}.cls-2{fill:#c9b5ff;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M328.6,418a45,45,0,0,1-9.7-1,47.2,47.2,0,1,1,35.3-6.7A46.6,46.6,0,0,1,328.6,418Zm0-91.8a44.8,44.8,0,1,0,43.8,54h0a44.7,44.7,0,0,0-34.5-53A49,49,0,0,0,328.6,326.2Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1933.6,913.8a27.5,27.5,0,1,1,26.5-34.3h0a27.6,27.6,0,0,1-19.5,33.5A33.4,33.4,0,0,1,1933.6,913.8Zm0-53.5a26.1,26.1,0,1,0,26.1,26,25,25,0,0,0-.9-6.6,25.9,25.9,0,0,0-25.3-19.4Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1615.4,813.7a72.4,72.4,0,1,1,18.6-2.4A72.4,72.4,0,0,1,1615.4,813.7Zm.3-143.5a71.3,71.3,0,1,0,71.1,71.4,75.2,75.2,0,0,0-2.3-18.3h0A71.5,71.5,0,0,0,1615.7,670.2Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1659,501.5l-.3-.3-84.9-85.5.3-.3,84.9-85.5.3.3,84.9,85.5-.3.3Zm-84-85.8,84,84.6,84.1-84.6L1659,331Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1795.6,694.1l-68.2-68.2.2-.2,68-68.1,68.3,68.3-.3.2Zm-67.3-68.2,67.3,67.3,67.3-67.3-67.4-67.3Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1849.7,673.2l-47.4-47.3.2-.2,47.2-47.1,47.2,47.3v.2ZM1803,625.9l46.7,46.6,46.6-46.6-46.6-46.7Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M303.7,737.1a22.9,22.9,0,1,1,5.9-.8A23.3,23.3,0,0,1,303.7,737.1Zm.1-45.4a22.6,22.6,0,1,0,22.5,22.6,23.2,23.2,0,0,0-.8-5.8h0A22.5,22.5,0,0,0,303.8,691.7Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M1887.3,470a14.2,14.2,0,1,1-.1-28.4,14.2,14.2,0,0,1,3.7,27.9A11.2,11.2,0,0,1,1887.3,470Zm0-28a14.7,14.7,0,0,0-3.6.4,14,14,0,0,0-9.8,17.2,13.5,13.5,0,0,0,6.3,8.3,14,14,0,0,0,19.1-5,14.5,14.5,0,0,0,1.4-10.6h0A13.8,13.8,0,0,0,1887.3,442Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M162.9,691.3,61.2,589.6,162.9,487.8,264.6,589.6ZM62.1,589.6,162.9,690.4,263.6,589.6,162.9,488.8Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M207.5,646l-89.4-89.4,89.4-89.4,89.4,89.4Zm-88.4-89.4L207.5,645,296,556.6l-88.5-88.5Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M179.5,680.7l-66.1-66.1,66.1-66.2,66.2,66.2Zm-65.2-66.1,65.2,65.2,65.3-65.2-65.3-65.2Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterBackground);
export default __webpack_public_path__ + "static/media/footerBackground.85662a076dd7545955ddbddb5e840f49.svg";
export { ForwardRef as ReactComponent };